// Converts any user-provided map value into an embeddable Google Maps iframe URL.
// Accepts: a full embed URL, a pasted <iframe> snippet, a Maps link with @lat,lng
// or ?q=, a plain "lat,lng", or a plain address string.
export function toMapEmbed(value, fallbackQuery = "India") {
  const val = (value || "").toString().trim();
  const fallback = `https://www.google.com/maps?q=${encodeURIComponent(fallbackQuery)}&output=embed`;
  if (!val) return fallback;

  // Already an embeddable URL
  if (val.includes("/maps/embed") || val.includes("output=embed")) return val;

  // User pasted a full <iframe ... src="..."> snippet
  const iframeSrc = val.match(/src=["']([^"']+)["']/i);
  if (iframeSrc) {
    const s = iframeSrc[1];
    return s.includes("output=embed") || s.includes("/maps/embed") ? s : `${s}${s.includes("?") ? "&" : "?"}output=embed`;
  }

  // Coordinates embedded in a Maps URL (@lat,lng or !3dLAT!4dLNG)
  const at = val.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (at) return `https://www.google.com/maps?q=${at[1]},${at[2]}&output=embed`;
  const bang = val.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/);
  if (bang) return `https://www.google.com/maps?q=${bang[1]},${bang[2]}&output=embed`;

  // Maps URL with a q= parameter
  const q = val.match(/[?&]q=([^&]+)/);
  if (q) return `https://www.google.com/maps?q=${q[1]}&output=embed`;

  // A generic URL we can't parse (e.g. shortlink) — can't embed reliably
  if (/^https?:\/\//i.test(val)) return fallback;

  // Plain address or "lat,lng" text
  return `https://www.google.com/maps?q=${encodeURIComponent(val)}&output=embed`;
}
